// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = require('./_export');

$export($export.P + $export.R, 'Map', { toJSON: require('./_collection-to-json')('Map') });



//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/core-js/library/modules/es7.map.to-json.js
// module id = l8TX
// module chunks = 0